export const MuiListItemButton = {
  styleOverrides: {
    root: {
      '&:hover, &.hover': {
        backgroundColor: 'transparent',
      },
    },
  },
};
